if (!customElements.get('spotlight-slider')) {
  customElements.define(
    'spotlight-slider',
    class SpotlightSlider extends HTMLElement {
      constructor() {
        super()
        this.container = this.closest('.spotlight-slider')
        this.videos = this.querySelectorAll('video')
        this.slides = this.querySelectorAll('[data-slide]')
        this.swiperInit = false
        this.initEvents()
      }

      initEvents() {
        this.slideCount = this.slides.length

        this.initSwiper()
        window.addEventListener('resize', () => {
          this.initSwiper()
        })
      }

      initSwiper() {
        if (window.innerWidth < 1024) {
          if (this.swiperInit) {
            this.swiper.destroy()
            this.swiperInit = false
          }
        } else {
          if (!this.swiperInit) {
            this.swiper = new Swiper(this.querySelector('[data-media-swiper]'), {
              slidesPerView: 'auto',
              spaceBetween: 16,
            })
            this.swiper.on('slideChange', (args) => {
              if (args.activeIndex == 0) {
                args.el.classList.remove('mx-auto', 'mr-0', 'ml-auto')
                args.el.classList.add('ml-0', 'mr-auto')
              } else if (args.activeIndex == this.slideCount - 1) {
                args.el.classList.remove('mx-auto', 'mr-auto', 'ml-0')
                args.el.classList.add('mr-0', 'ml-auto')
              } else {
                args.el.classList.remove('ml-auto', 'mr-auto', 'ml-0', 'mr-0')
                args.el.classList.add('mx-auto')
              }
            })
            this.slides.forEach((slide) => {
              slide.addEventListener('click', (e) => {
                const target = e.target.classList.contains('swiper-slide')
                  ? e.target
                  : e.target.closest('.swiper-slide')
                if (!target.classList.contains('swiper-slide-active'))
                  this.swiper.slideTo(parseInt(target.dataset.slide), 500)
              })
              slide.addEventListener('mouseenter', (e) => {
                if (this.swiperInit) {
                  const target = e.target.classList.contains('swiper-slide')
                    ? e.target
                    : e.target.closest('.swiper-slide')
                  const slideIndex = parseInt(target.dataset.slide)
                  if (!target.classList.contains('swiper-slide-active')) {
                    if (
                      (this.swiper.activeIndex === 0 && slideIndex === 1) ||
                      (this.swiper.activeIndex === this.slides.length - 1 && slideIndex === this.slides.length - 2)
                    ) {
                      this.swiper.el.classList.remove('lg:w-88.4percent')
                      this.swiper.el.classList.add('lg:w-9/12')
                    } else if (this.slides.length > 2 && slideIndex < this.swiper.activeIndex) {
                      this.swiper.el.classList.remove('mx-auto')
                      this.swiper.el.classList.add('mr-0', 'ml-auto')
                    } else if (this.slides.length > 2 && slideIndex > this.swiper.activeIndex) {
                      this.swiper.el.classList.remove('mx-auto')
                      this.swiper.el.classList.add('ml-0', 'mr-auto')
                    }
                  }
                }
              })
              slide.addEventListener('mouseleave', (e) => {
                if (this.swiperInit) {
                  const target = e.target.classList.contains('swiper-slide')
                    ? e.target
                    : e.target.closest('.swiper-slide')
                  const slideIndex = parseInt(target.dataset.slide)
                  if (!target.classList.contains('swiper-slide-active')) {
                    if (
                      (this.swiper.activeIndex === 0 && slideIndex === 1) ||
                      (this.swiper.activeIndex === this.slides.length - 1 && slideIndex === this.slides.length - 2)
                    ) {
                      this.swiper.el.classList.remove('lg:w-9/12')
                      this.swiper.el.classList.add('lg:w-88.4percent')
                    } else if (this.slides.length > 2 && slideIndex < this.swiper.activeIndex) {
                      this.swiper.el.classList.add('mx-auto')
                      this.swiper.el.classList.remove('mr-0', 'ml-auto')
                    } else {
                      this.swiper.el.classList.add('mx-auto')
                      this.swiper.el.classList.remove('ml-0', 'mr-auto')
                    }
                  }
                }
              })
            })
          }
          this.swiperInit = true
        }

        // Turn videos in only viewports.
        document.addEventListener(
          'scroll',
          () => {
            this.toggleVideos(isInViewport(this.container))
          },
          {
            passive: true,
          },
        )
      }
      toggleVideos(turn = false) {
        this.videos.forEach((video) => (turn ? video.play() : video.pause()))
      }
    },
  )
}
